"use client";

import { useState } from "react";
import { X } from "lucide-react";
import { lerTemaSalvo, salvarTemaUsuario, type TemaUsuario } from "@/lib/tema-usuario";
import { Button } from "./Button";
import { Dialog } from "./Dialog";
import { useExperienciaProduto } from "./ExperienciaProvider";

export function PopupTema({ onClose }: { onClose: () => void }) {
  const { dados } = useExperienciaProduto();
  const [tema, setTema] = useState<TemaUsuario>(() => lerTemaSalvo(dados?.papel));

  function selecionar(valor: TemaUsuario) {
    if (!dados) return;
    setTema(valor);
    salvarTemaUsuario(dados.papel, valor);
  }

  return (
    <Dialog open onOpenChange={(aberto) => { if (!aberto) onClose(); }} aria-labelledby="titulo-popup-tema">
      <div className="flex items-center justify-between gap-3">
        <h2 id="titulo-popup-tema" className="text-xl font-semibold">Tema</h2>
        <Button variant="ghost" size="icon" aria-label="Fechar tema" onClick={onClose}><X className="h-5 w-5" /></Button>
      </div>
      <div role="radiogroup" aria-label="Tema" className="mt-5 space-y-2">
        {([["claro", "Claro"], ["escuro", "Escuro"]] as const).map(([valor, rotulo]) => (
          <label
            key={valor}
            className={`flex cursor-pointer items-center gap-3 rounded-[var(--fz-field-radius)] border px-4 py-3 text-sm transition-colors hover:bg-[var(--fz-floating-hover)] focus-within:ring-2 focus-within:ring-[var(--fz-field-focus-ring)] ${tema === valor ? "border-[var(--fz-field-border-focus)] bg-[var(--fz-floating-hover)]" : "border-[var(--fz-field-border)]"}`}
          >
            <input
              type="radio"
              name="tema-popup"
              value={valor}
              checked={tema === valor}
              onChange={() => selecionar(valor)}
              className="h-4 w-4 accent-[var(--fz-button-primary-bg)]"
            />
            {rotulo}
          </label>
        ))}
      </div>
    </Dialog>
  );
}
